// extracted by mini-css-extract-plugin
module.exports = {"popup":"floating-box__popup___271mN"};